<template>
    <CustomSelectOne :name="name" :items="items" :empty-value="emptyValue" v-model="internalValue"
                     item-label="label" item-value="value" :label="label" v-if="loading" :required="required"
                     :placeholder="placeholder" :filter="filter" :rules="rules"
                     :noPlaceholder="noPlaceholder"/>
</template>

<script>
    import CustomSelectOne from "./inner/CustomSelectOne";
    import {getAllHistoryType} from "@/swagger/vue-api-client";

    export default {
        name: "CustomSelectOneHistoryActionType",

        components: {CustomSelectOne},

        props: {
            name: {
                type: String,
            },
            label: {
                type: String,
            },
            emptyValue: {
                type: Boolean,
                default: false,
            },
            modelValue: null,
            disabled: {
                type: Boolean,
                default: false,
            },
            required: {
                type: Boolean,
                default: false,
            },
            placeholder: {
                type: String,
                default: "",
            },
            filter: {
                type: Boolean,
                default: false,
            },
            rules: undefined,
            noPlaceholder: {
                type: Boolean,
                default: false,
            },
        },

        emits: ["update:modelValue"],

        computed: {
            internalValue: {
                get() {
                    return this.modelValue;
                },
                set(value) {
                    this.$emit("update:modelValue", value);
                },
            },
        },

        data() {
            return {
                items: [],
                loading: false,
            };
        },

        beforeMount() {
            getAllHistoryType().then((response) => {
                this.items = response.data;
                this.loading = true;
            });
        }
    };
</script>

<style lang="scss">
</style>
